import React from 'react'
import style from './css/WhatsApp.module.css'
import whatsappIcon from './assests/whatsapp.png'

function WhatsApp() {
  return (
    <>
       <div className={style.whatsaap}>
        <a href="https://wa.me/9128414128" target='blank'>
            <img src={whatsappIcon} alt="whatsaap"/>
        </a>
    </div>
    </>
  )
}

export default WhatsApp
